import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const usePlaceBid = (onSuccess?: any, onError?: any) => {
  const axios = useAxios();
  const { t } = useTranslation();
  const urlKey = t("place-bid-api");
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: {
      propertyId: string;
      amount: string;
      contactId: string;
      pofFileName: string | null;
      rpaFileName: string | null;
      purchaseType: any;
      buyerBeenInside: any;
      referralFee?: any;
      buysInName: any;
      lender: string;
      buyerVesting?: string;
    }) => {
      const res = await axios.post(urlKey, data);
      return res;
    },
    onSuccess: async (
      data,
      variables: {
        propertyId: string;
        amount: string;
        contactId: string;
        pofFileName: string | null;
        rpaFileName: string | null;
        purchaseType: any;
        buyerBeenInside: any;
        referralFee?: any;
        buysInName: any;
        lender: string;
        buyerVesting?: string;
      }
    ) => {
      if (onSuccess) {
        onSuccess(data);
        await queryClient.setQueryData(
          [`Property-Detail`, variables.propertyId],
          (oldData: any) => {
            if (!oldData) return oldData;
            const updatedData = {
              ...oldData.data,
              bidCount: oldData.data.bidCount + 1
            };
            return { ...oldData, data: updatedData };
          }
        );
        await queryClient.refetchQueries({ queryKey: ["view-bids"] });
      }
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
